import usePosSearch from './usePosSearch';

export default usePosSearch;
